import { JudgeDetailPresenter } from '@/presentation/presenters/judge/judgeDetailPresenter'
import { JudgeDetailViewModel } from '@/presentation/viewmodels/judge/judgeDetailViewModel'

export function useJudgeDetailPresenter(
  presenter: JudgeDetailPresenter = new JudgeDetailPresenter(new JudgeDetailViewModel())
) {
  return {
    judgeDetail: presenter.judgeDetail,
    testJudgeDetail: presenter.testJudgeDetail
  }
}
